import React, { useCallback, useEffect, useState } from 'react';
import styles from './UIGameVote.module.scss';
import clsx from 'clsx';
import { T } from '@colonist/ui';
import { UIGameTimerBar } from '../UIGameTimerBar/UIGameTimerBar.tsx';
import { PlayerColor } from '@colonist/game-states';
import { UIGameVoteParticipants } from './UIGameVoteParticipants/index.ts';
import { UIGameVoteActions } from './UIGameVoteActions/index.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import IconX from '@static/images/icon_x.svg';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { getVoteViewState } from './VoteViewState.ts';
export const UIGameVote = ({ voteState, onVoteAccept, onVoteReject, onHideVote, className })=>{
    const initialTimeLeftMs = voteState.duration - voteState.timePassed;
    const [timeLeftMs, setTimeLeftMs] = useState(initialTimeLeftMs);
    const myColor = useGameStore((state)=>state.myColor);
    const voteViewState = getVoteViewState(voteState, myColor);
    useEffect(()=>{
        AudioManager.play(AudioType.VoteReminder);
    }, []);
    useEffect(()=>{
        setTimeLeftMs(initialTimeLeftMs);
        if (timeLeftMs <= 0) return;
        const interval = setInterval(()=>{
            setTimeLeftMs((prev)=>{
                const next = prev - 100;
                if (next <= 0) {
                    clearInterval(interval);
                    return 0;
                }
                return next;
            });
        }, 100);
        return ()=>clearInterval(interval);
    }, [
        initialTimeLeftMs
    ]);
    const timeLeftPercentage = Math.max(0, Math.min(1, timeLeftMs / voteState.duration)) * 100;
    const onAccept = useCallback(()=>{
        onVoteAccept(voteState.id);
    }, [
        onVoteAccept,
        voteState.id
    ]);
    const onReject = useCallback(()=>{
        onVoteReject(voteState.id);
    }, [
        onVoteReject,
        voteState.id
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, /*#__PURE__*/ React.createElement("img", {
        src: IconX,
        className: styles.closeButton,
        onClick: onHideVote
    }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: voteViewState.title
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.description
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.vote.playersRequiredForVoteToPass',
            options: {
                count: voteState.requiredNumberOfAcceptVotesToPass
            }
        }
    })), voteViewState.showWaitingMessage && /*#__PURE__*/ React.createElement("div", {
        className: styles.waitingMessage
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:game.vote.waitingForOtherPlayers"
    }))), /*#__PURE__*/ React.createElement(UIGameVoteParticipants, {
        acceptedVotes: voteState.acceptedVotes,
        declinedVotes: voteState.declinedVotes,
        participatingPlayers: voteState.participatingPlayers
    }), /*#__PURE__*/ React.createElement(UIGameTimerBar, {
        isAnimated: true,
        timeLeftPercentage: timeLeftPercentage,
        className: styles.timerBar,
        currentTurnPlayerColor: PlayerColor.Orange
    }), voteViewState.showActions && /*#__PURE__*/ React.createElement(UIGameVoteActions, {
        response: voteViewState.viewerVoteResponse,
        onAccept: onAccept,
        onDecline: onReject
    }));
};
